import { Button } from "@material-ui/core";
import React, { useRef, useEffect, useState, useMemo } from "react";
import { getBackendUrl } from "../../config";

const LS_NAME = "audioMessageRate";

function resolveAudioCandidates(url) {
  if (!url || typeof url !== "string") return [];
  const out = [];
  const push = u => {
    if (u && !out.includes(u)) out.push(u);
  };
  push(url);
  try {
    const u = new URL(url, window.location.origin);
    const mediaMatch = u.pathname.match(/\/(?:media|wt-files)\/whaticket\/(.+)$/i);
    if (mediaMatch?.[1]) {
      push(
        `${u.origin}/whaticket-media-serve.php?f=${encodeURIComponent(
          decodeURIComponent(mediaMatch[1])
        )}`
      );
      push(`${u.origin}/wt-files/whaticket/${mediaMatch[1]}`);
    }
    const serveMatch = url.match(/whaticket-media-serve\.php\?f=([^&]+)/i);
    if (serveMatch?.[1]) {
      const rel = decodeURIComponent(serveMatch[1]);
      push(`${u.origin}/wt-files/whaticket/${rel}`);
      const base = (getBackendUrl() || "").replace(/\/$/, "");
      const file = rel.split("/").pop();
      if (base && file) push(`${base}/public/${file}`);
    }
  } catch {
    // ignore
  }
  return out.filter(Boolean);
}

export default function AudioPlayer({ url }) {
  const audioRef = useRef(null);
  const [audioRate, setAudioRate] = useState(
    parseFloat(localStorage.getItem(LS_NAME) || "1")
  );
  const [showButtonRate, setShowButtonRate] = useState(false);
  const candidates = useMemo(() => resolveAudioCandidates(url), [url]);
  const [idx, setIdx] = useState(0);
  const src = candidates[idx] || url;

  useEffect(() => {
    setIdx(0);
  }, [url]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.playbackRate = audioRate;
    }
    localStorage.setItem(LS_NAME, audioRate);
  }, [audioRate]);

  useEffect(() => {
    const el = audioRef.current;
    if (!el) return undefined;
    el.onplaying = () => setShowButtonRate(true);
    el.onpause = () => setShowButtonRate(false);
    el.onended = () => setShowButtonRate(false);
    el.onerror = () => {
      setIdx(current => (current + 1 < candidates.length ? current + 1 : current));
    };
    return undefined;
  }, [candidates, src]);

  const toogleRate = () => {
    let newRate = null;
    switch (audioRate) {
      case 0.5:
        newRate = 1;
        break;
      case 1:
        newRate = 1.5;
        break;
      case 1.5:
        newRate = 2;
        break;
      case 2:
        newRate = 0.5;
        break;
      default:
        newRate = 1;
        break;
    }
    setAudioRate(newRate);
  };

  return (
    <>
      <audio key={src} ref={audioRef} controls src={src} preload="metadata" />
      {showButtonRate && (
        <Button
          style={{ marginLeft: "5px", marginTop: "-45px" }}
          onClick={toogleRate}
        >
          {audioRate}x
        </Button>
      )}
    </>
  );
}
